// tslint:disable:object-literal-sort-keys
export const API_ENDPOINTS = {

    action: '/actions',
    addressBook: '/address-book',
    address: '/addresses',
    authority: '/authorities',
    album: '/albums',
    alias: '/aliases',
    archive: '/archives',
    batch: '/batches',
    collaborator: '/collaborators',
    collection: '/collections',
    collectionItem: '/collectionItems',
    conditionReport: '/conditionReports',
    container: '/containers',
    containerModel: '/containerModels',
    domain: '/domains',
    entity: '/entity',
    entityField: '/entityField',
    entry: '/entries',
    expo: '/expo',
    expositionProject: '/exposition-projects',
    favorite: '/favorites',
    item: '/items',
    accessoryItem: '/accessory-items',
    numericAccessoryItem: '/numeric-accessory-items',
    physicalAccessoryItem: '/physical-accessory-items',
    biblioItem: '/biblio-items',
    numericBiblioItem: '/numeric-biblio-items',
    physicalBiblioItem: '/physical-biblio-items',
    containerItem: '/container-items',
    numericContainerItem: '/numeric-container-items',
    physicalContainerItem: '/physical-container-items',
    filmItem: '/film-items',
    numericFilmItem: '/numeric-film-items',
    physicalFilmItem: '/physical-film-items',
    museumItem: '/museum-items',
    numericMuseumItem: '/numeric-museum-items',
    physicalMuseumItem: '/physical-museum-items',
    loanProject: '/loan-projects',
    restorationProject: '/restoration-projects',
    outProject: '/out-projects',
    diffusionProject: '/diffusion-projects',
    locationRoomProject: '/locationRoom-projects',
    transcodingProject: '/transcoding-projects',
    acquisitionProject: '/acquisition-projects',
    programmingProject: '/programming-projects',
    borrowingProject: '/borrowing-projects',
    language: '/languages',
    deviceProject: '/device-projects',
    outgoingDepositProject: '/outgoing-depot-projects',
    enteringDepositProject: '/entering-depot-projects',
    project: '/projects',
    auditProject: '/audit-projects',
    location: '/locations',
    manifestation: '/manifestations',
    accessoryManifestation: '/accessory-manifestations',
    numericAccessoryManifestation: '/numeric-accessory-manifestations',
    physicalAccessoryManifestation: '/physical-accessory-manifestations',
    biblioManifestation: '/biblio-manifestations',
    numericBiblioManifestation: '/numeric-biblio-manifestations',
    physicalBiblioManifestation: '/physical-biblio-manifestations',
    filmManifestation: '/film-manifestations',
    numericFilmManifestation: '/numeric-film-manifestations',
    physicalFilmManifestation: '/physical-film-manifestations',
    museumManifestation: '/museum-manifestations',
    numericMuseumManifestation: '/numeric-museum-manifestations',
    physicalMuseumManifestation: '/physical-museum-manifestations',
    containerManifestation: '/container-manifestations',
    numericContainerManifestation: '/numeric-container-manifestations',
    physicalContainerManifestation: '/physical-container-manifestations',
    label: '/labels',
    linkableItem: '/linkable-item',
    linkableArchiveItem: '/linkable-item',
    mission: '/missions',
    missionPattern: '/mission-patterns',
    taskPattern: '/task-patterns',
    propertyRights: '/property-rights',
    histories: '/histories',
    recordMask: '/record-masks',
    metaRecordMask: '/meta-record-masks',
    formatter: '/formatters',
    searchMask: '/search-masks',
    media: '/medias',
    movement: '/movements',
    entityMenu: '/entity-menus',
    menuEntry: '/menuEntry',
    preEntry: '/preEntries',
    skinObject: '/skinObject',
    thesaurus: '/thesaurus',
    thesaurusTerm: '/thesaurusTerm',
    translation: '/translations',
    user: '/users',
    work: '/works',
    biblioWork: '/biblio-works',
    filmWork: '/film-works',
    museumWork: '/museum-works',
    task: '/tasks',
    process: '/processes',
    search: '/search',
    entitySearch: '/entity-search',
    uploadMedia: '/uploadMedias',
    fileRecord: '/filerecords',
    original: '/filerecords',
    domainSearch: '/domain-search',
    tag: '/tags',
    domainContext: '/domain-contexts',
    videoTranscodingConfigs: '/video-transcodingconfigs',
    audioTranscodingConfigs: '/audio-transcodingconfigs',
    imageTranscodingConfigs: '/image-transcodingconfigs',
    transcodingConfigs: '/transcodingconfigs',
    savedSearch: '/saved-search',
    downloadMedias: '/downloadMedias',
    fsFile: '/fs.files',
    email: '/email',
    group: '/groups',
    numbering: '/numerotation',
    workspace: '/workspace',
    workspaceMenu: '/workspace-menu',
    institution: '/institution',
    expression: '/expressions',
    oaiGroup: '/oai-groups',
    oaiRequest: '/oai-requests',
    oaiSet: '/oai-sets',
    oai: '/oai',
    event: '/event',
    site: '/sites',
    intervention: '/intervention',
    output: '/output',
    recolement: '/recolement',
    printableReport: '/printablereport',
    export: '/export',
    import: '/import',
    skosCollection: '/skosCollection',
    webExport: '/web-exports',
    webExportPage: '/web-export-pages',
    exportedContent: '/exported-contents',
    fieldFormat: '/fieldFormats',
    exportTemplate: '/export-templates',
    fileRetentionProject: '/fileRetention-projects',
    patrimonialItem: '/patrimonial-items',
    technicalItem: '/technical-items',
    thematicCollection: '/thematic-collection',
    liveShowExpression: '/live-show-expressions',
    liveShowWork: '/live-show-works',
    specimen: '/specimens'
}